/* eslint-disable no-extra-boolean-cast */
import { isArray, isEmpty, isNil, isString } from 'lodash'
import { careFindJobStore } from '~/features/care-find-job/care-find-job.store'
import { masterStore } from '~/stores'

export const toSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

export const mappingJobSearchData = (lastSaveSearch) => {
	const lastSaveSearchFilter = {}
	if (lastSaveSearch) {
		const {
			external_id,
			keyword,
			max_wage,
			min_wage,
			near_by,
			min_matching_percentage,
			radius,
			shifts,
			skill_name,
			disciplines,
			posted_in_days,
			job_types,
			location_states,
			location_cities,
			start_date,
			facility_types,
		} = lastSaveSearch
		if (external_id) {
			lastSaveSearchFilter.externalId = external_id
		}
		if (start_date) {
			if (isArray(start_date)) {
				lastSaveSearchFilter.startDate = {
					from: start_date[0],
					to: start_date[1],
				}
			} else {
				lastSaveSearchFilter.startDate = {
					from: start_date.from,
					to: start_date.to,
				}
			}
		}
		if (keyword) {
			lastSaveSearchFilter.keyword = keyword
		}
		if (max_wage) {
			lastSaveSearchFilter.maxWage = max_wage
		}
		if (near_by) {
			lastSaveSearchFilter.nearBy = near_by
		}
		if (min_wage) {
			lastSaveSearchFilter.minWage = min_wage
		}

		if (posted_in_days) {
			lastSaveSearchFilter.postedInDays = posted_in_days
		}
		if (disciplines) {
			lastSaveSearchFilter.disciplines = disciplines
		}

		if (location_cities) {
			lastSaveSearchFilter.locationCities = location_cities
		}

		if (location_states) {
			lastSaveSearchFilter.locationStates = location_states
		}
		if (job_types) {
			lastSaveSearchFilter.jobTypes = job_types
		}

		if (min_matching_percentage) {
			lastSaveSearchFilter.minMatchingPercentage = min_matching_percentage
		}

		if (radius) {
			lastSaveSearchFilter.radius = radius
			lastSaveSearchFilter.initRadius = radius
		}

		if (shifts) {
			lastSaveSearchFilter.shifts = shifts
		}

		if (skill_name) {
			lastSaveSearchFilter.specialties = skill_name
		}
		if (facility_types) {
			lastSaveSearchFilter.facilityTypes = facility_types
		}
	}

	return lastSaveSearchFilter
}

export const mappingFilterJobSearch = (searchData, _isShowLocation = false) => {
	const searchDataFilter = {}

	if (searchData) {
		const {
			minMatchingPercentage,
			nearBy,
			shifts,
			externalId,
			isActive,
			keyword,
			minWage,
			location,
			jobTypes,
			locationStates,
			locationCities,
			specialty,
			startDate,
			facilityTypes,
			businessSectorNames,
			specialtyIds,
			disciplineId,
			disciplineIds,
		} = searchData
		if (keyword) {
			searchDataFilter.keyword = keyword
		}

		if (externalId) {
			searchDataFilter.externalId = externalId
		} else {
			if (!isEmpty(disciplineId)) {
				searchDataFilter.disciplineIds = [disciplineId]
			}

			if (!isEmpty(disciplineIds) && !isEmpty(disciplineId)) {
				searchDataFilter.disciplineIds = disciplineIds
			}

			if (!isNil(minMatchingPercentage)) {
				searchDataFilter.minMatchingPercentage = minMatchingPercentage || 0
			}

			if (shifts) {
				searchDataFilter.shifts = shifts
			}

			if (specialtyIds) {
				searchDataFilter.specialtyIds = specialtyIds
			}

			if (specialty) {
				searchDataFilter.specialtyIds = specialty.map((item) => item.value)
			}

			if (externalId) {
				searchDataFilter.externalId = externalId
			}
			if (jobTypes) {
				searchDataFilter.jobTypes = jobTypes
			}
			if (startDate) {
				if (isArray(startDate)) {
					searchDataFilter.startDate = {
						from: startDate[0],
						to: startDate[1],
					}
				} else {
					searchDataFilter.startDate = {
						from: startDate.from,
						to: startDate.to,
					}
				}
			}
			if (locationStates) {
				searchDataFilter.locationStates = locationStates
			}

			if (nearBy) {
				searchDataFilter.nearBy = {
					lat: null,
					long: null,
					radius: nearBy?.radius,
				}
			}
			if (locationCities) {
				searchDataFilter.locationCities = locationCities
			}

			if (location && location.length > 0) {
				const cities = location.filter((location) => location.type === 'locationCity').map((item) => item.value)
				const states = location.filter((location) => location.type === 'locationState').map((item) => item.value)

				searchDataFilter.addressCities = cities
				searchDataFilter.addressStates = states

				if (cities.length === 1 || states.length > 0 || !nearBy?.radius) {
					const radiusValue = isNil(location) || location?.every((item) => item.type !== 'locationCity')
					if (!radiusValue) {
						if (nearBy) {
							searchDataFilter.nearBy = {
								lat: null,
								long: null,
								radius: nearBy?.radius,
							}
						}
					}
				}
			}
			if (!isNil(minWage)) {
				searchDataFilter.minWage = minWage
			}
			if (isActive) {
				searchDataFilter.isActive = isActive
			}
			if (facilityTypes) {
				searchDataFilter.facilityTypes = facilityTypes
			}

			if (businessSectorNames && businessSectorNames.length > 0) {
				searchDataFilter.businessSectorNames = businessSectorNames
			}
		}
	}

	return searchDataFilter
}

export const convertStateToArray = (data) => {
	return {
		...data,
		locationState: isString(data?.locationStates) ? data?.locationStates?.split(',') : data?.locationStates,
	}
}

export const convertStateToString = (data) => {
	return {
		...data,
		locationStates: data?.locationStates,
	}
}

export const mappingSkillName = (data) => {
	const skillNameLength = data?.specialties?.length
	const disciplines = data?.disciplines

	return (!!disciplines && skillNameLength === 0) || (!!disciplines && !skillNameLength)
		? {
				...data,
				specialtyIds: careFindJobStore.disciplineOptions(disciplines).map((item) => item?.value),
		  }
		: data
}

export const convertCommaSeparatedValuesToArray = (obj) => {
	for (let key in obj) {
		if (typeof obj[key] === 'string' && obj[key].includes(',')) {
			obj[key] = obj[key].split(',')
		}
	}
	return obj
}

export const convertToCorrectTypes = async (object) => {
	const allowedKeys = ['specialty', 'shifts', 'locationCity', 'locationState', 'disciplines', 'jobType']
	const values = Object.keys(object)
		.filter((key) => allowedKeys.includes(key))
		.reduce((filteredObj, key) => {
			filteredObj[key] = object[key]
			return filteredObj
		}, {})

	if (values.hasOwnProperty('locationState')) {
		const locationStates = values?.locationState?.split(',')
		if (locationStates.length > 1) {
			values.locationStates = locationStates
			delete values.locationCity
		} else {
			if (values.hasOwnProperty('locationCity')) {
				values.locationCities = [`${values?.locationCity}, ${values?.locationState}`]
			}
		}
	}
	if (values.hasOwnProperty('jobType')) {
		values.jobTypes = values.jobType
	}

	values.shifts = values?.shifts?.split(',')
	if (values.hasOwnProperty('specialty')) {
		values.specialties = values?.specialty?.split(',')
		delete values.specialty
	}

	return values
}

export const mappingObjectToArrayField = (obj) => {
	return Object.entries(obj).map(([key, value]) => {
		return {
			key,
			value,
		}
	})
}

export function convertToUSPhoneFormat(phoneNumber) {
	if (phoneNumber) {
		// Remove the leading '+1'
		let formattedNumber
		phoneNumber = phoneNumber.substring(2)
		// Remove any non-numeric characters from the input phone number
		phoneNumber = phoneNumber.replace(/\D+/g, '')
		// Check if the phone number is 10 digits or 7 digits
		if (phoneNumber.length === 10) {
			// Format the phone number as "xxx-xxx-xxxx"
			formattedNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
		} else if (phoneNumber.length === 9) {
			// Format the phone number as "xxx-xxx-xxx"
			formattedNumber = phoneNumber.replace(/(\d{3})(\d{4})/, '$1-$2')
		} else {
			// Return an error message for invalid phone numbers
			return 'Error: Invalid phone number'
		}
		return formattedNumber
	}
}

/**
 * Formats an international phone number dynamically
 * Handles different country codes and formats appropriately
 * @param {string} phoneNumber - Phone number with country code (e.g., "+11234567890", "+442071234567")
 * @returns {string} Formatted phone number
 */
export function formatInternationalPhone(phoneNumber) {
	if (!phoneNumber) return ''

	// Remove all non-digit characters except the leading +
	const cleaned = phoneNumber.replace(/[^\d+]/g, '')

	// Check if it starts with +
	if (!cleaned.startsWith('+')) {
		return phoneNumber // Return as-is if no country code
	}

	// Extract country code and phone number
	const phoneWithoutPlus = cleaned.substring(1)

	// Detect country code patterns
	// US/Canada: +1 (10 digits)
	if (cleaned.startsWith('+1') && phoneWithoutPlus.length === 11) {
		const areaCode = phoneWithoutPlus.substring(1, 4)
		const prefix = phoneWithoutPlus.substring(4, 7)
		const lineNumber = phoneWithoutPlus.substring(7, 11)
		return `+1 (${areaCode}) ${prefix}-${lineNumber}`
	}

	// UK: +44 (10 digits after country code)
	if (cleaned.startsWith('+44') && phoneWithoutPlus.length === 12) {
		const areaCode = phoneWithoutPlus.substring(2, 5)
		const part1 = phoneWithoutPlus.substring(5, 9)
		const part2 = phoneWithoutPlus.substring(9, 12)
		return `+44 ${areaCode} ${part1} ${part2}`
	}

	// Philippines: +63 (10 digits after country code)
	if (cleaned.startsWith('+63') && phoneWithoutPlus.length === 12) {
		const areaCode = phoneWithoutPlus.substring(2, 5)
		const part1 = phoneWithoutPlus.substring(5, 8)
		const part2 = phoneWithoutPlus.substring(8, 12)
		return `+63 ${areaCode} ${part1} ${part2}`
	}

	// India: +91 (10 digits after country code)
	if (cleaned.startsWith('+91') && phoneWithoutPlus.length === 12) {
		const part1 = phoneWithoutPlus.substring(2, 7)
		const part2 = phoneWithoutPlus.substring(7, 12)
		return `+91 ${part1} ${part2}`
	}

	// Australia: +61 (9 digits after country code)
	if (cleaned.startsWith('+61') && phoneWithoutPlus.length === 11) {
		const areaCode = phoneWithoutPlus.substring(2, 3)
		const part1 = phoneWithoutPlus.substring(3, 7)
		const part2 = phoneWithoutPlus.substring(7, 11)
		return `+61 ${areaCode} ${part1} ${part2}`
	}

	// Generic international format for other countries
	// Format as: +XX XXX XXX XXXX (or similar based on length)
	const countryCodeMatch = phoneWithoutPlus.match(/^(\d{1,3})(\d+)/)
	if (countryCodeMatch) {
		const countryCode = countryCodeMatch[1]
		const restOfNumber = countryCodeMatch[2]

		// Split the rest of the number into groups of 3-4 digits
		const formatted = restOfNumber.replace(/(\d{3})(?=\d)/g, '$1 ')
		return `+${countryCode} ${formatted}`.trim()
	}

	// Fallback: return as-is if format is unrecognized
	return phoneNumber
}

export function convertKeysToSnakeCase(obj) {
	if (typeof obj !== 'object' || obj === null) {
		return obj // Return as is if obj is not an object or is null
	}

	if (Array.isArray(obj)) {
		// If obj is an array, recursively convert keys for each item in the array
		return obj.map((item) => convertKeysToSnakeCase(item))
	}

	const snakeCaseObj = {}
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			// Convert key to snake case
			const snakeCaseKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
			// Recursively convert keys for nested objects
			snakeCaseObj[snakeCaseKey] = convertKeysToSnakeCase(obj[key])
		}
	}
	return snakeCaseObj
}

export function listBannerDismiss(banners) {
	let result = {}
	if (!!banners) {
		banners.forEach((banner) => {
			if (banner?.name === 'Welcome Banner') {
				result.welcomeBanner = {
					isDismissed: !banner?.isDismissed,
					id: banner?.id,
				}
			} else if (banner?.name === 'Referral Banner') {
				result.referralBanner = {
					isDismissed: !banner?.isDismissed,
					id: banner?.id,
				}
			} else if (banner?.name === 'Matching Banner') {
				result.matchingBanner = {
					isDismissed: !banner?.isDismissed,
					id: banner?.id,
				}
			} else if (banner?.name === 'Contact Recruiter Banner') {
				result.contactRecruiterBanner = {
					isDismissed: !banner?.isDismissed,
					id: banner?.id,
				}
			}
		})
	}
	return result
}

export function getIdsFromDismissedBanners(banners, condition) {
	const result = []
	if (banners?.welcomeBanner?.isDismissed === condition) {
		result.push(banners?.welcomeBanner?.id)
	}
	if (banners?.contactRecruiterBanner?.isDismissed === condition) {
		result.push(banners?.contactRecruiterBanner?.id)
	}
	return result
}

export const mappingTags = (tag_names) => {
	switch (tag_names) {
		case 'screening':
			return {
				title: 'Screening',
				status: 'start',
			}
		case 'job_submitted':
			return {
				title: 'Job Submitted',
				status: 'start',
			}
		case 'interview_scheduled':
			return {
				title: 'Scheduled Interview',
				status: 'pending',
			}
		case 'interview_accepted':
			return {
				title: 'Accepted Interview',
				status: 'pending',
			}
		case 'interview_cancelled':
			return {
				title: 'Cancelled Interview',
				status: 'fail',
			}
		case 'interview_rejected':
			return {
				title: 'Rejected Interview',
				status: 'fail',
			}
		case 'candidate_rescheduled':
			return {
				title: 'Rescheduled',
				status: 'pending',
			}
		case 'client_confirmed':
			return {
				title: 'Client Confirmed',
				status: 'pending',
			}
		case 'client_rejected':
			return {
				title: 'Client Rejected',
				status: 'fail',
			}
		case 'interview_failed':
			return {
				title: 'Interview Completed',
				status: 'success',
			}
		case 'interview_completed':
			return {
				title: 'Interview Completed',
				status: 'success',
			}
		case 'interview_passed':
			return {
				title: 'Interview Completed',
				status: 'success',
			}
		case 'offer_sent':
			return {
				title: 'Offer Sent',
				status: 'pending',
			}
		case 'offer_rejected':
			return {
				title: 'Offer Rejected',
				status: 'fail',
			}
		case 'contract_signed':
			return {
				title: 'Contract Signed',
				status: 'success',
			}
		default:
			return {
				title: 'Screening',
				status: 'start',
			}
	}
}
export const mappingStatusColor = (status) => {
	switch (status) {
		case 'start':
			return '#1AA7EC'
		case 'pending':
			return '#1E2F97'
		case 'success':
			return '#309102'
		case 'fail':
			return '#FF2727'
		default:
			return '#1AA7EC'
	}
}
export function getLastNameFirstName(str) {
	if (str) {
		const nameArray = str.split(' ') // Split the string into an array using the space as a separator
		return {
			firstName: nameArray[0],
			lastName: nameArray[1],
		}
	}
}
export function updateArray(dataBE, dataSelect) {
	if (isArray(dataBE) && isArray(dataSelect)) {
		const res = [...dataBE]

		dataSelect.forEach((state) => {
			const found = res.find((item) => item.preferredWorkingState === state)
			if (!found) {
				res.push({ preferredWorkingState: state })
			}
		})

		res.forEach((item) => {
			if (!dataSelect.includes(item.preferredWorkingState)) {
				item._destroy = true
			}
		})

		return res
	}
}

export function removeFalsyProps(obj) {
	// Create a new object to store the truthy properties
	const newObj = {}

	// Loop through each property in the original object
	for (const key in obj) {
		// Check if the property value is truthy or null/undefined
		if (obj[key] || obj[key] === '' || obj[key] === 0) {
			// Add the property to the new object
			newObj[key] = obj[key]
		} else if (obj[key] === null || obj[key] === undefined) {
			// Replace null/undefined values with empty string
			newObj[key] = ''
		}
	}

	// Return the new object with only truthy properties
	return newObj
}
export const handleCaculateProgress = (data) => {
	return Math.floor((data / 6) * 100) || 0
}

export const showMappingAddress = (data) => {
	if (!data) {
		return ''
	}

	const { city, state, country } = data

	const addressParts = []

	if (city) {
		addressParts.push(city)
	}

	if (state) {
		addressParts.push(state)
	}

	if (country) {
		addressParts.push(country)
	}

	return addressParts.join(', ') || ''
}

export const mappingItemPicklistDispline = (array, isDiscipline = false) => {
	return array?.map((item) => {
		if (isDiscipline) {
			const specialties = mappingItemPicklistSpecialty(item?.specialties)

			return {
				label: item?.name,
				value: item?.name,
				specialties,
			}
		}

		return {
			label: item?.name,
			value: item?.name,
		}
	})
}

export const mappingItemPicklistSpecialty = (array) => {
	return array?.map((item) => {
		return {
			...item,
			label: item?.label,
			value: item?.name,
		}
	})
}

export const mappingStringToLocation = (data = [], isState) => {
	if (!isState) {
		return data.map((item) => ({
			label: item,
			value: item,
			type: 'locationCity',
		}))
	}
	return masterStore.licenseStates
		?.filter((x) => data.includes(x.value))
		.map((item) => {
			return {
				label: item.label,
				value: item.value,
				type: 'locationState',
			}
		})
}
